import {
  addObj,
  getPage,
  getDetail,
  modifyObj,
  deleteObj,
  getMyPage,
  confirmRemind,
} from '@/api/earnedpremiumplanserv'

export default {
  state: {
    state_EarnedPremiumPlan_AddObjResult: null,
    state_EarnedPremiumPlan_GetPageResult: null,
    state_EarnedPremiumPlan_GetDetailResult: null,
    state_EarnedPremiumPlan_ModifyObjResult: null,
    state_EarnedPremiumPlan_DeleteObjResult: null,
    state_EarnedPremiumPlan_GetMyPageResult: null,
    state_EarnedPremiumPlan_ConfirmRemindResult: null,
  },
  mutations: {
    SET_EARNEDPREMIUMPLAN_ADDOBJ_RESULT: (state, rst) => {
      state.state_EarnedPremiumPlan_AddObjResult = rst;
    },
    SET_EARNEDPREMIUMPLAN_GETPAGE_RESULT: (state, rst) => {
      state.state_EarnedPremiumPlan_GetPageResult = rst;
    },
    SET_EARNEDPREMIUMPLAN_GETDETAIL_RESULT: (state, rst) => {
      state.state_EarnedPremiumPlan_GetDetailResult = rst;
    },
    SET_EARNEDPREMIUMPLAN_MODIFYOBJ_RESULT: (state, rst) => {
      state.state_EarnedPremiumPlan_ModifyObjResult = rst;
    },
    SET_EARNEDPREMIUMPLAN_DELETEOBJ_RESULT: (state, rst) => {
      state.state_EarnedPremiumPlan_DeleteObjResult = rst;
    },
    SET_EARNEDPREMIUMPLAN_GETMYPAGE_RESULT: (state, rst) => {
      state.state_EarnedPremiumPlan_GetMyPageResult = rst;
    },
    SET_EARNEDPREMIUMPLAN_CONFIRMREMIND_RESULT: (state, rst) => {
      state.state_EarnedPremiumPlan_ConfirmRemindResult = rst;
    },
  },
  actions: {
    EarnedPremiumPlanServ_AddObj({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        addObj(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_EARNEDPREMIUMPLAN_ADDOBJ_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_EARNEDPREMIUMPLAN_ADDOBJ_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    EarnedPremiumPlanServ_GetPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_EARNEDPREMIUMPLAN_GETPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_EARNEDPREMIUMPLAN_GETPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    EarnedPremiumPlanServ_GetDetail({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getDetail(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_EARNEDPREMIUMPLAN_GETDETAIL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_EARNEDPREMIUMPLAN_GETDETAIL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    EarnedPremiumPlanServ_ModifyObj({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        modifyObj(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_EARNEDPREMIUMPLAN_MODIFYOBJ_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_EARNEDPREMIUMPLAN_MODIFYOBJ_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    EarnedPremiumPlanServ_DeleteObj({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        deleteObj(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_EARNEDPREMIUMPLAN_DELETEOBJ_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_EARNEDPREMIUMPLAN_DELETEOBJ_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    EarnedPremiumPlanServ_GetMyPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getMyPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_EARNEDPREMIUMPLAN_GETMYPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_EARNEDPREMIUMPLAN_GETMYPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    EarnedPremiumPlanServ_ConfirmRemind({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        confirmRemind(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_EARNEDPREMIUMPLAN_CONFIRMREMIND_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_EARNEDPREMIUMPLAN_CONFIRMREMIND_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
  },
  getters:{
    get_EarnedPremiumPlan_AddObjResult: state => {
      return state.state_EarnedPremiumPlan_AddObjResult;
    },
    get_EarnedPremiumPlan_GetPageResult: state => {
      return state.state_EarnedPremiumPlan_GetPageResult;
    },
    get_EarnedPremiumPlan_GetDetailResult: state => {
      return state.state_EarnedPremiumPlan_GetDetailResult;
    },
    get_EarnedPremiumPlan_ModifyObjResult: state => {
      return state.state_EarnedPremiumPlan_ModifyObjResult;
    },
    get_EarnedPremiumPlan_DeleteObjResult: state => {
      return state.state_EarnedPremiumPlan_DeleteObjResult;
    },
    get_EarnedPremiumPlan_GetMyPageResult: state => {
      return state.state_EarnedPremiumPlan_GetMyPageResult;
    },
    get_EarnedPremiumPlan_ConfirmRemindResult: state => {
      return state.state_EarnedPremiumPlan_ConfirmRemindResult;
    },
  }
}